import { renderHTML } from '../utils/functions';

const FeatureImage = ({ post, attributes }) => {
	const { link, thumbnail, title, categories } = post;
	const { layout, isFImg, isFImgLink, isMeta, isMetaCategory, metaCategoryIn, isLinkNewTab } = attributes;

	const condition = 'slider' === layout ? isFImg : isFImg && thumbnail;

	return condition ? <figure className='apbPostFImg'>
		{thumbnail && <>
			{isFImgLink ? <a href={link} target={isLinkNewTab ? '_blank' : '_self'} rel='noreferrer' aria-label={title}><img src={thumbnail} alt={title} /></a> : <img src={thumbnail} alt={title} />}

			{(isMeta && isMetaCategory && 'image' === metaCategoryIn) && <div className='apbPostFImgCats'>
				{renderHTML(categories.space)}
			</div>}
		</>}
	</figure> : null;
};
export default FeatureImage;